<template>
  <div
    v-if="value > 0"
    class="badge-numeric"
    :class="{ overfilled: overfilled, [size]: true }"
  >
    {{ formattedValue }}
  </div>
</template>

<script>
export default {
  name: 'BadgeNumeric',
  props: {
    value: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', 'md'].includes(value)
      },
      default: 'md'
    }
  },
  computed: {
    overfilled() {
      const { value } = this
      return value >= 10
    },
    formattedValue() {
      const { value, overfilled } = this
      return overfilled ? '9+' : value
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-numeric {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-red-600);
  color: var(--color-white);
  font-size: var(--font-size-body-1);
  line-height: var(--leading-180);
  font-weight: var(--weight-normal);
  z-index: 1;
  width: 1.8em;
  height: 1.8em;
  border-radius: var(--border-radius-rounded);

  &.sm {
    font-size: var(--font-size-body-2);
    line-height: var(--leading-170);
    font-weight: var(--weight-normal);
    width: 1.5em;
    height: 1.5em;
  }

  &.overfilled {
    height: 1.8em;
    width: 1.8em;
  }

  @include phone {
    font-size: var(--font-size-body-2);
    line-height: var(--leading-170);
    font-weight: var(--weight-normal);
  }
}
</style>
